import * as Yup from 'yup'

export const CampaignTargetSchema = Yup.object().shape({
  start_date: Yup.date().required('Campaign start date is required.'),
  end_date: Yup.date()
    .required('Campaign end date is required.')
    .min(Yup.ref('start_date'), 'End date must be on or after start date.'),
  gross_reach_target: Yup.number().integer("This value must be an integer").typeError('Must be a number'),
  influencer_target: Yup.number().integer("This value must be an integer").typeError('Must be a number'),
  influencer_budget: Yup.number().typeError('Must be a number'),
  action_count_target: Yup.number().typeError('Must be a number'),
  net_reach_target: Yup.number().typeError('Must be a number'),
  impressions_target: Yup.number().typeError('Must be a number'),
  social_budget: Yup.number().typeError('Must be a number'),
  media_budget: Yup.number().typeError('Must be a number'),
  travel_cost_target: Yup.number().typeError('Must be a number'),
  attendance_cost_target: Yup.number().typeError('Must be a number'),
  currency: Yup.string().required('This field is required.')
});

/** Campaign Overview targets modal: dates are not editable here, but currency is. */
export const CampaignOverviewTargetsSchema = CampaignTargetSchema.omit(['start_date', 'end_date'])
